import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[oscTableScrollTarget]' })
export class TableScrollTargetDirective {
    @Input('oscTableScrollTarget') public scrollToValue: any;

    public constructor(public readonly elementRef: ElementRef) {}
}
